import { render } from "./Launch.vue?vue&type=template&id=233f2b12&scoped=true&ts=true"
import script from "./Launch.vue?vue&type=script&lang=ts"
export * from "./Launch.vue?vue&type=script&lang=ts"

import "./Launch.vue?vue&type=style&index=0&id=233f2b12&scoped=true&lang=css"

import exportComponent from "/Users/chad/work/cocos_cc/vue_cc_launch/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233f2b12"]])

export default __exports__